import HexagonCluster from "../icons/HexagonCluster";
import ListIcon from "../icons/ListIcon";

type OverviewToggleProps = {
  isMapActive: boolean;
  handleToggle: () => void;
};

export const OverviewToggle = ({
  isMapActive,
  handleToggle,
}: OverviewToggleProps) => {
  return (
    <button
      onClick={handleToggle}
      aria-label="Toggle view"
      className="col-span-full ml-4 mr-6 hidden w-[112px] items-center justify-center justify-self-end medium:flex"
    >
      <div
        className={`${
          isMapActive ? "bg-white" : "bg-tab-border"
        } rounded-l-full border border-tab-border`}
      >
        <div className="flex h-10 w-14 items-center justify-center">
          <HexagonCluster
            fill={isMapActive ? "#1C7B7C" : "#888888"}
            className="h-6 w-6"
          />
        </div>
      </div>

      <div
        className={`${
          isMapActive ? "bg-tab-border" : "bg-white"
        } items-center rounded-r-full border border-tab-border`}
      >
        <div className="flex h-10 w-14 items-center justify-center">
          <ListIcon
            fill={isMapActive ? "#888888" : "#1C7B7C"}
            className="h-6 w-6"
          />
        </div>
      </div>
    </button>
  );
};
